import {Component} from '@angular/core';
import {DateHelper, FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {BisherigeBetrieblicheVerhaeltnisseAngaben} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-bisherige-betriebliche-verhaeltnisse-vortaetigkeit',
  templateUrl: './vortaetigkeit.component.html'
})
export class VortaetigkeitComponent extends FormBaseComponent<BisherigeBetrieblicheVerhaeltnisseAngaben> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      bisherigeTaetigkeitVorhanden: [this.data.bisherigeTaetigkeitVorhanden],
      bisherigeTaetigkeit: [this.data.bisherigeTaetigkeit, [
        this.validatorService.maxLength(100)
      ]],
      ort: [this.data.ort, [
        this.validatorService.maxLength(100)
      ]],
      dauerVon: [this.data.dauerVon, [
        this.validatorService.date(),
        this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.dauerVon),
          this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
      ]],
      dauerBis: [this.data.dauerBis, [
        this.validatorService.date(),
        this.validatorService.conditionTrue(() => DateHelper.isNotInFuture(this.data.dauerBis),
          this.translateService.instant('COMMON_UI.VALIDATION.DATE_IS_IN_FUTURE'))
      ]],
      ustIdentifikationsnummer: [this.data.ustIdentifikationsnummer, [
        this.validatorService.pattern(ValidationPattern.UST_ID,
          this.translateService.instant('COMMON_UI.VALIDATION.USTID_PATTERN'))
      ]],
      wirtschaftsIdNummer: [this.data.wirtschaftsIdNummer, [
        this.validatorService.pattern(ValidationPattern.WIRTSCHAFTS_ID,
          this.translateService.instant('COMMON_UI.VALIDATION.WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN'))
      ]]
    });
  }
}
